<template lang="pug">
	div.container-fluid
		filtro(:filtro="filtro", @buscar="buscar", @nuevo="editar = 'nuevo'")
		resultados.mt-3(:orden="orden", :resultados="resultados", @editar="editarInvitado($event)", @descargar="descargar")
		editor(
			v-if="editar"
			:invitado-id="editar"
			@cerrar="cerrarEditor"
			@guardado="guardado"
		)
</template>
<script>
import Filtro from './filtro'
import Resultados from './resultados'
import Editor from '../editor/main'
import API from '../../api'
export default {
	components: {
		filtro: Filtro,
		resultados: Resultados,
		editor: Editor
	},
	data () {
		return {
			orden: {
				OrdenColumna: 'Nombre',
				OrdenSentido: 'asc'
			},
			filtro: {
				EventoID: null,
				Nombre: null,
				Fila: null,
				Asiento: null,
				Localizacion: null,
				Estados: {
					'No Avisado': true,
					Pendiente: true,
					Entregado: true,
					Confirmado: true,
					Denegado: false
				},
				Usuario: null,
				VIP: null
			},
			resultados: [],
			editar: null
		}
	},
	methods: {
		cerrarEditor () {
			this.editar = null
		},
		editarInvitado (invitado) {
			this.editar = invitado.InvitadoID
		},
		guardado () {
			this.editar = null
			this.buscar()
		},
		buscar () {
			API.buscarInvitados(this.filtro)
				.then(res => {
					this.resultados = res.data
				})
				.catch(e => {
					this.$store.commit('alertas/error', {
						titulo: 'Error',
						mensaje: e.response.data.error
					})
				})
		},
		descargar () {
			API.download(this.filtro, this.orden)
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/modulos/invitaciones/vue/components/buscador/index.vue